<template>
   <div id="step1">

      <div class="wrapper stepUp">
       <div class="d23"></div>
      <div class= "formaWrap">
      <div class= "step">
        <p class= "stepWrap current">1</p>
        <svg width="7" height="29" viewBox="0 0 7 29" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'nextstep'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.875 28.216a.593.593 0 01-.558-.794l4.586-12.739a1.4 1.4 0 000-.948L.317.996A.593.593 0 011.433.594l4.73 13.14a1.4 1.4 0 010 .95l-4.73 13.14a.593.593 0 01-.558.392z" fill="#000F38" fill-opacity=".2"/></svg>
        <p class= "stepWrap">2</p>
        <svg width="7" height="29" viewBox="0 0 7 29" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'nextstep'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.875 28.216a.593.593 0 01-.558-.794l4.586-12.739a1.4 1.4 0 000-.948L.317.996A.593.593 0 011.433.594l4.73 13.14a1.4 1.4 0 010 .95l-4.73 13.14a.593.593 0 01-.558.392z" fill="#000F38" fill-opacity=".2"/></svg>
        <p class= "stepWrap">3</p>
        </div>
      <p class="fillContact">Заполните контактную информацию</p>
        <form action="" v-show="control">
            <ul>
                <li>
                  <div class="formCenter">
                    <input type="text" v-model="lastName" placeholder="Фамилия" v-on:blur="blurLast">

                  </div>
                  <p v-if="ErrLastName.length > 0" class=errMsg>{{ErrLastName}}</p>
                </li>
                <li>
                   <div class="formCenter">
                    <input type="text" v-model="firstName" placeholder="Имя" v-on:blur="blurFirst">

                    </div>
                    <p v-if="ErrFirstName.length > 0" class=errMsg>{{ErrFirstName}}</p>
                </li>
                <li>
                   <div class="formCenter">
                    <input type="text" v-model="middleName" placeholder="Отчество" v-on:blur="blurMiddle">

                    </div>
                    <p v-if="ErrMiddleName.length > 0" class=errMsg>{{ErrMiddleName}}</p>
                 </li>
                <li>
                   <div class="formCenter">
                  <input type="tel" v-model="mobilePhone" placeholder="Телефон" v-mask="'+7 (###) ###-##-##'" v-on:blur="blurPhone">

                </div>
                <p v-if="ErrmobilePhone.length > 0" class=errMsg>{{ErrmobilePhone}}</p>
                </li>
                <li>
                   <div class="formCenter">
                  <div class="datePlaceholder">
                    <!-- <input type="text"  placeholder="Дата рождения" v-if="!focused" class="fakeInput"> -->
                    <p  v-if="!focused" class="fakeInput">Дата рождения</p>
                    <input type="date"  v-model="birthDate" v-on:blur="blurDate" v-on:focus="onFocus" >
                    </div>
                    <p v-if="ErrbirthDate.length > 0" class=errMsg>{{ErrbirthDate}}</p>
                     </div>

                    </li>
                </ul>

        </form>
                <button type="button" class="btn" v-on:click.prevent="nextStep" >Далее</button>


      </div>
      </div>
      </div>
</template>

<script>
  import {mapState} from 'vuex'

export default {
  name: 'step1',
  data(){
return{
   ErrLastName:'',
   ErrFirstName:'',
   ErrMiddleName:'',
   ErrmobilePhone:'',
    ErrbirthDate:'',
    control: true,
    focused: false,
}
},
methods:{
// nextStep(){
// this.$store.commit('incStepForm')
// },
        nextStep(){
      this.blurLast();
      this.blurFirst();
      this.blurMiddle();
      this.blurPhone();
      this.blurDate();
      if (this.ErrLastName.length == 0 &&  this.ErrFirstName.length == 0 &&  this.ErrMiddleName.length == 0 &&  this.ErrmobilePhone.length == 0 &&  this.ErrbirthDate.length == 0){

        this.$myApi.singleRequest({
          action:'stepSave',
          step:'screen_1',
          stepCode:1,
          session:this.session
        }).then((res)=>{res['asd']='asd';}).catch((res)=>{res['asd']='asd';});

        this.$store.commit('incStepForm');

          try {
            // eslint-disable-next-line
            ym(82222150, 'reachGoal', '1step')
          }
          catch(e){
            console.log(e)
          }
          }
},
onFocus() {
  console.log('tut')
      this.focused = true
    },

    blurLast(){
        if (this.lastName.length == 0){
            this.ErrLastName ='обязательное поле';
        } else {
            this.ErrLastName ='';
        }
    },
    blurFirst(){
        if (this.firstName.length == 0){
            this.ErrFirstName ='обязательное поле';
        } else {
            this.ErrFirstName ='';
        }
    },
    blurMiddle(){
        if (this.middleName.length == 0){
            this.ErrMiddleName ='обязательное поле';
        } else {
            this.ErrMiddleName ='';
        }
    },
     blurPhone(){
        if (this.mobilePhone.length == 0){
            this.ErrmobilePhone ='обязательное поле';
        } else {
              if (this.mobilePhone.length == 18){
                this.ErrmobilePhone ='';
              } else {
                this.ErrmobilePhone ='некорректный номер телефона';
              }
        }
    },
    blurDate(){
      // eslint-disable-next-line

       let today = new Date();
      let birthDate = new Date(this.birthDate);
      let timeDiff = today.getTime() - birthDate.getTime();
      let diffyears = Math.floor((timeDiff / (1000 * 60 * 60 * 24)/365));


        if (diffyears < 18 || diffyears > 100){
           this.ErrbirthDate ='недопустимый возраст';
        }   else {
            this.ErrbirthDate ='';
       }

       if (this.birthDate.length == 0){
         this.focused = false;
            this.ErrbirthDate ='oбязательное поле';
       }

    },
},
  computed:{
    ...mapState({
      valueVuex: state => state.alfaForm.alfaForm,
      session:state=>state.alfaForm.session,
    }),
    lastName:{
      get(){
        return this.valueVuex['lastName'];
      },
      set(value){
        this.$store.commit('setStateAlfaRoot',{
          formKey:'lastName',
          value:value
        })
      }
    },
    firstName:{
      get(){
        return this.valueVuex['firstName'];
      },
      set(value){
        this.$store.commit('setStateAlfaRoot',{
          formKey:'firstName',
          value:value
        })
      }
    },
    middleName:{
      get(){
        return this.valueVuex['middleName'];
      },
      set(value){
        this.$store.commit('setStateAlfaRoot',{
          formKey:'middleName',
          value:value
        })
      }
    },
     mobilePhone:{
      get(){
        return this.valueVuex['mobilePhone'];
      },
      set(value){
        this.$store.commit('setStateAlfaRoot',{
          formKey:'mobilePhone',
          value:value
        })
      }
    },
    birthDate:{
      get(){
        return this.valueVuex["passport"]['birthDate'];
      },
        set(value){
        this.$store.commit('setStateAlfaChildren',{
          parent: 'passport',
          formKey:'birthDate',
          value:value
        })
      }
    },
  },
  mounted(){
    this.$store.commit('loadingStatus', false);

  }
}
</script>

<style scoped>
/deep/.errMsg{color: red;position: absolute;font-size: 3vw;width: 100%; }
#step1{ height: 164vw;}
.formaWrap {top: -132vw;height: 150vw;}
.d23 {height: 131vw;}
button{position: absolute;bottom: 7vw;right: 23vw;}
.datePlaceholder .fakeInput{color: #676767; font-family: Arial, sans-serif;bottom: calc(50% - 28vw); pointer-events: none; position: absolute; background-color: #F5F6FC ;left: calc(50% - 29vw)}

.datePlaceholder{left: 151px;bottom: 231px;}
.formCenter{margin-left: auto; margin-right: auto; }
input{width: 58vw; height: 4.5vw;}
input[type = date]{ height:4.5vw;-webkit-appearance: none;}
li input{ margin-bottom: 0vw;}
li {padding-top:2vw; padding-bottom:2vw;}



@media screen and (min-width: 1140px) {
    ul{  display: grid;grid-template-columns: repeat(2, 1fr);grid-auto-rows: 0px; grid-column-gap: 0px;grid-row-gap: 90px; padding-right: 120px;padding-left: 120px;}
    form{padding-bottom: 134px;}
    #step1{height: 674px;}
    /deep/.errMsg{width: 38.7%; font-size: 16px; padding-top: 0vw;}
    button{left: 390px; position: absolute;bottom: 40px;}
    .formaWrap {top: -464px;height: 642px;}
    .d23 {height: 467px;}
    li input { margin-bottom: 0px;height: 27px;}
    .datePlaceholder{left: 151px;bottom: 231px;}
    li {padding-top: 20px; padding-bottom:0px;}
    input{width: 335px; height: 40px;}
    .formCenter{width: 100%;}
    input[type = date]{height: 27px;}
   .datePlaceholder .fakeInput{left: calc(50% - 372.5px);font-size: 23px; bottom: calc(50% - 100px);}
   


    }





</style>
